/* eslint-disable max-classes-per-file */
import Module from '@/scripts/old/classes/Module';

const NAMESPACE = 'data-lang-switcher';

class LangSwitcher {
  constructor(el, btn) {
    this.onBtnClickShim = (e) => {
      this.onBtnClick(e);
    };

    this.onOutsideClickShim = (e) => {
      this.onOutsideClick(e);
    };

    this.el = el;
    this.btn = btn;
    this.isActive = this.el.classList.contains('_active');
    this.setEvents();
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    this.btn[action]('click', this.onBtnClickShim);
    document[action]('click', this.onOutsideClickShim);
  }

  destroy() {
    this.setEvents(false);
  }

  onBtnClick(e) {
    e.preventDefault();
    this.toggle();
  }

  onOutsideClick(e) {
    const target = e.target;
    if (!this.isActive || (target === this.el || this.el.contains(target))) return;
    this.toggle();
  }

  toggle() {
    this.el.classList[this.isActive ? 'remove' : 'add']('_active');
    this.isActive = !this.isActive;
  }
}

class LangSwitchersModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const btn = el.querySelector(`[${NAMESPACE}-btn]`);

    if (!btn) return;

    const langSwitcher = new LangSwitcher(el, btn);

    this.instances.set(el, langSwitcher);
  }

  destroyInstance(instance) {
    instance.destroy();
  }
}

export default new LangSwitchersModule();
